import SortAsc from './SortAsc'

export default SortAsc
// eslint-disable-next-line import/export
export * from './SortAsc'
